import { redactSensitiveQuery } from "./scrub-breadcrumb"

export type ScrubbableRequestEvent = {
  request?: {
    url?: unknown
    query_string?: unknown
    headers?: Record<string, unknown>
  } | null
}

const SENSITIVE_HEADER_KEYS = new Set(["authorization", "cookie", "x-canary-token"])

function redactQueryString(raw: string): string {
  const needsPrefix = raw.length > 0 && !raw.startsWith("?") && !raw.startsWith("&")
  const redacted = redactSensitiveQuery(needsPrefix ? `?${raw}` : raw)
  return needsPrefix ? redacted.slice(1) : redacted
}

export function scrubSentryRequest<E extends ScrubbableRequestEvent>(event: E): E {
  const request = event.request
  if (!request) return event

  if (typeof request.url === "string") {
    request.url = redactSensitiveQuery(request.url)
  }
  if (typeof request.query_string === "string") {
    request.query_string = redactQueryString(request.query_string)
  }
  if (request.headers && typeof request.headers === "object") {
    for (const key of Object.keys(request.headers)) {
      if (SENSITIVE_HEADER_KEYS.has(key.toLowerCase())) {
        delete request.headers[key]
      }
    }
  }

  return event
}
